import AcradeIcon from '../assets/images/icon-arcade.svg'
import AdvancedIcon from '../assets/images/icon-advanced.svg'
import ProIcon from '../assets/images/icon-pro.svg'

export const plansData = [
    {
        id: 1,
        title: 'Acrade',
        monthlyFee: 9,
        yearlyFee: 90,
        monthlyFreeTrial: 2,
        iconUrl: AcradeIcon
    },

    {
        id: 2,
        title: 'Advanced',
        monthlyFee: 12,
        yearlyFee: 120,
        monthlyFreeTrial: 2,
        iconUrl: AdvancedIcon
    },

    {
        id: 3,
        title: 'Pro',
        monthlyFee: 15,
        yearlyFee: 150,
        monthlyFreeTrial: 2,
        iconUrl: ProIcon
    }
]